import { render } from "./WorkTypeDetailModal.vue?vue&type=template&id=6becff16"
import script from "./WorkTypeDetailModal.vue?vue&type=script&lang=ts"
export * from "./WorkTypeDetailModal.vue?vue&type=script&lang=ts"
script.render = render

export default script